import { schema } from "normalizr";
import { gameEntity } from "./game";

export const questionEntity = new schema.Entity("questions", {
  gameId: gameEntity,
});
